export class GoogleTracking {

    track(name: string, status: string) {
        console.log('tracking ' + name + ', status ' + status);
        // @ts-ignore
        if (typeof track_google_analytics_event === 'function') {
            // @ts-ignore
            track_google_analytics_event(name, status);
        }

    }

}
